export const SESSION_TOKEN_HEADER_NAME = 'X-Session-Token'
export const CLIENT_VERSION_HEADER_NAME = 'X-Client-Version'
